import { Link, Message } from 'Components/Core';
import { withInjectedProps } from 'Components/Core/InjectedPropsContext';
import { TestResultsDestinationInjectedProviderProps } from './types';

let AutoImportWorksheetTestResultsDestinations: React.FC<TestResultsDestinationInjectedProviderProps> = ({
  readableWorksheets,
  imports,
}) => {
  return (
    <Message>
      The results of this test will be automatically exported to the following test{imports.length > 1 ? 's' : ''}:
      <ul>
        {imports.map(({ SampleId, LinkId, WorksheetType }: any, index: number) => (
          <li key={index}>
            {readableWorksheets.includes(WorksheetType.Id) ? (
              <Link to={`/worksheets/${LinkId}`}>
                {WorksheetType.Caption} on {SampleId}
              </Link>
            ) : (
              `${WorksheetType.Caption} on ${SampleId}`
            )}
          </li>
        ))}
      </ul>
    </Message>
  );
};

AutoImportWorksheetTestResultsDestinations = withInjectedProps(AutoImportWorksheetTestResultsDestinations);

export { AutoImportWorksheetTestResultsDestinations };
export default AutoImportWorksheetTestResultsDestinations;
